module.exports = "/assets/packs/images/4b5ef16991e0a6e251077adf1f02571b.png";